export const CAT_SPECIES = 'Cat';
export const DOG_SPECIES = 'Dog';
export const CAT_SPECIES_CODE = 'FELINE';
export const DOG_SPECIES_CODE = 'CANINE';

export const MALE_GENDER = 'Male';
export const FEMALE_GENDER = 'Female';
export const MALE_GENDER_ID = 2;
export const FEMALE_GENDER_ID = 1;

export const SUCCES_SUMMARY_CODE = '0';
export const SELECT_PAYMENT = 1;
export const ENTER_CREDIT_CARD = 2;
export const SUMMARY = 3;

export const ACTION_TYPE = {
  PAYNOW: 'paynow',
  UPDATE_REIMBURSEMENT: 'update-reimbursement',
  UPDATE_BANK: 'update-bank'
};

export const STATUS_RESOLVED = 'resolved';
export const STATUS_IDLE = 'idle';
export const STATUS_PENDING = 'pending';

export const FREQUENCY_MONTHLY = 'MONTHLY';
export const FREQUENCY_ANNUALLY = 'ANNUALLY';
export const FREQUENCY_FORTNIGHTLY = 'FORTNIGHTL';

export const FREQUENCY_CODE_MONTHLY = 'MONTHLY';
export const FREQUENCY_CODE_FORTNIGHTLY = 'FORTNIGHTL';
export const FREQUENCY_CODE_ANNUALLY = 'ANNUALLY';

export const FREQUENCY_LABELS = {
  FORTNIGHTL: 'Fortnightly',
  MONTHLY: 'Monthly',
  ANNUALLY: 'Annually'
};

export const PER_FREQUENCY_LABELS = {
  FORTNIGHTL: 'Fortnight',
  MONTHLY: 'Month'
};

export const PAYMENT_ERROR =
  'An unexpected error has occurred in the application. Please try again. If you continue to experience the error please contact our customer support.';

export const STEP_1_ENTER_DETAILS = 1;
export const STEP_2_REVIEW_SUBMIT = 2;
export const STEP_3_CONFIRMATION = 3;

// Note: The value '1753' is hardcoded because the FromDate and ToDate fields in the policy/policyVets API response are set to '1753-01-01T00:00:00' instead of null.
export const DEFAULT_YEAR_VALUE = '1753';

export const PETSURE_UNDERWRITER = 'P';
export const HOLLARD_UNDERWRITER = 'H';

export const PAYMENT_METHOD = {
  BANK: 'BANK',
  CREDIT_CARD: 'CC',
  CHEQUE: 'CHEQUE'
};

export const PAYMENT_METHOD_OPTION = {
  CARD: 0,
  DIRECT_DEBIT: 1
};

export const LOGICAL_CLAIM_STATUS = {
  PAID: 'PAID',
  PAIDDNR: 'PAIDDNR',
  NOTADMITTED: 'NOTADMITTED',
  NOTCOVERED: 'NOTCOVERED',
  ONHOLDACTIONREQUIRED: 'ONHOLDACTIONREQUIRED',
  INPROGRESS: 'INPROGRESS',
  WORKINGONIT: 'WORKINGONIT',
  DNR: 'DNR',
  APPROVED: 'APPROVED',
  APPROVEDCORRESPONDENCE: 'APPROVEDCORRESPONDENCE',
  COMMSPENDING: 'Communication Pending'
};

export const CLAIM_STATUS_CODES = {
  // In Progress statuses
  INITIAL_CLAIM_LODGED: '100_IN',
  CALCULATION_IN_PROGRESS: '105_CALC',
  ADDITIONAL_CALCULATION_IN_PROGRESS: '105A_CALC',
  PENDING_AUTHORISATION: '701_PAUTH',
  UNDER_AUDIT: '707_AUDIT',
  HEALTH_VERIFICATION_ASSESSMENT: '250_HVA',
  NEW_CLAIM_LODGED: '202_NLODG',
  NEW_CLAIM_LODGED_VARIANT: '203_NLODG',
  GOP_AUTHORISATION: '700_GOPAUT',
  GOP_AUTHORISATION_VARIANT: '704_GOPAUT',
  BENEFIT_CALCULATION_NOT_AVAILABLE: '601_BCNA',
  ON_HOLD_GENERIC: '500_OH',
  HANDLING_REVIEW: '500_HR',
  NOT_ADMITTED: '600_NOTAD',
  HIGH_CARE_REVIEW_REQUIRED: '708_HC',

  // On Hold / Action Required statuses
  MEDICAL_INFO_OUTSTANDING: '500_MIO',
  MEDICAL_DOCUMENTATION_REQUIRED: '500_MD',
  LETTER_CORRESPONDENCE_OUTSTANDING: '500_LEC',

  // Paid / Approved / Other outcomes
  CLAIM_PAID: '705_PAID',
  CLAIM_APPROVED: '702_AUTHOR',
  CLAIM_APPROVED_ACTION_REQUIRED: '500_BKD'
};

export const ACCOUNT_ERROR_RESPONSE_CODES = {
  USED_OLD_PW: 'USED_OLD_PW',
  INCORRECT_PASSWORD: 'Wrong email or password.',
  BLOCKED_ACCOUNT_STATUS_CODE: 429
};

export const PASSWORD_REGEX = {
  // Must have a digit
  PASSWORD_MUST_CONTAIN_DIGIT: /.*[0-9].*/,
  // Must have an uppercase letter
  PASSWORD_MUST_CONTAIN_UPPERCASE: /(?=.*[A-Z])/,
  // Min 8 characters
  PASSWORD_MUST_BE_MIN_8_CHARACTERS: /^.{8,}$/
};

export const AUTH0_SCOPE =
  'openid profile email mfa enroll read:authenticators remove:authenticators write:token read:policy read:claim write:claim write:policy';

export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const AU_MOBILE_REGEX = /^04/;
// Live vet
export const CHAT_TYPE = {
  VIDEO: 'video',
  TEXT: 'text'
};

export const GENDER_VALUE = {
  FEMALE_GENDER_VALUE: '2',
  MALE_GENDER_VALUE: '1'
};

export const PET_SPECIES = [
  { label: 'Dog', value: 'Canine' },
  { label: 'Cat', value: 'Feline' }
];

export const LIVE_VET_FAQ_GROUP = 'Live Vet';

export const EMPTY_RECORD_MESSAGE = {
  PAYNOW: 'No outstanding payments to display.',
  CLAIMS: 'You have no recent claims.',
  VETS: 'Sorry, there is no vet information to display at this time.'
};

export const GLM_PRODUCT_VERSION = {
  GLM2: 'GLM2',
  GLM3: 'GLM3'
};

export const TABLE_ROW_BATCH_SIZE = 10;

// Vet Details
export const VET_PRACTICE_SEARCH_SRINSTRUCTION =
  'Use this input to search for a vet practice. A list of practices will be created below that can be accessed using the tab key and selected using Enter or Space.';

export const SUCCESS_MESSAGES = {
  MULTI_PET: ' Note this change will apply to all pets.',
  UPDATE_EMAIL:
    'Thanks, your details will be updated. If your updated email address is different to the email address you have on your My Insurance Portal you will need to re-link your MyPet portal account using your updated email.'
};

export const AUTHENTICATION_TYPES = {
  MFA: '0',
  SSO: '1'
};

export const REIMBURSEMENT = {
  WITH: 'We pay approved claims to your bank account. Please check we have the correct details.',
  WITHOUT: 'We need your bank details in order to pay approved claims.'
};

export const CONTACT_US_MESSAGE = {
  DEFAULT: 'Contact us',
  FAQ: `Can't find what you're looking for? Contact us`
};

export const EVENT_KEY = {
  ESCAPE: 'Escape'
};

export const WELCOME_DASHBOARD = {
  TAKEATOUR: {
    SKIPPED: 0,
    COMPLETED: 1
  },
  TERMSOFUSE: {
    ACCEPTED: 1
  }
};

export const PCI_PAYMENT_ACTION = {
  PROCESSED: 'processed',
  CANCELLED: 'cancelled'
};

export const ACCOUNT_TYPES = {
  DIRECT_DEBIT: 'Direct Debit',
  CREDIT_CARD: 'Credit Card'
};

export const UNAVAILABLE_PAGE = {
  TITLE: 'Page Not Found.',
  MESSAGE: 'Sorry, this page is unavailable. Please contact our Customer Service team for assistance'
};

export const EXCESS_TYPE = {
  PER_CONDITION: 'Per Condition Excess',
  ANNUAL: 'Annual Excess'
};
